import { gql } from '@apollo/client'

export const GET_ADDRESS_VALIDATION = gql`
  query getAddressValidation($address: AddressInput!) {
    addressValidation(address: $address) {
      ... on AddressValidationSuccess {
        __typename
      }

      ... on AddressValidationProblem {
        __typename
        invalidInputs {
          field
          message
        }
      }
    }
  }
`
